import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  FLAG_GETTING_CABIN_CREW_BUS_ASSIGNMENTS,
  GET_CABIN_CREW_BUS_ASSIGNMENTS,
  CLEAR_CABIN_CREW_BUS_ASSIGNMENTS,
  FLAG_CABIN_CREW_BUS_ASSIGNMENT_ACTIVITY,
  CABIN_CREW_BUS_ASSIGNMENT_INITIAL_VALUES,
  GET_CABIN_CREW_BUS_ASSIGNMENT,
  CLEAR_CABIN_CREW_BUS_ASSIGNMENT,
} from '../types/traffic';
import {
  CABIN_CREW_BUS_ASSIGNMENT_ENDPOINT,
  CABIN_CREW_BUS_UNASSIGN_ENDPOINT,
  CABIN_CREW_BUS_ASSIGN_ENDPOINT,
  EXPORT_CABIN_CREW_BUS_ASSIGNMENT_ENDPOINT,
} from '../../config/endpoints';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_PUT_CONFIG,
  DEFAULT_POST_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';

const flagGettingCabinCrewAssignments = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_CABIN_CREW_BUS_ASSIGNMENTS,
    payload: flag,
  });

const getCabinCrewBusAssignments = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingCabinCrewAssignments(true));
    const query = tableFilters;
    const url = `${CABIN_CREW_BUS_ASSIGNMENT_ENDPOINT}?${QueryString.stringify(
      query,
    )}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const cabinCrewAssignments = await response.json();
    dispatch({
      type: GET_CABIN_CREW_BUS_ASSIGNMENTS,
      payload: cabinCrewAssignments,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingCabinCrewAssignments(false));
  }
};

const flagCabinCrewBusAssignmentActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_CABIN_CREW_BUS_ASSIGNMENT_ACTIVITY,
    payload: flag,
  });

const getCabinCrewBusAssignment =
  async ({ id }) =>
    async (dispatch) => {
      try {
        dispatch(flagCabinCrewBusAssignmentActivity(true));
        const url = `${CABIN_CREW_BUS_ASSIGNMENT_ENDPOINT}/${id}`;
        const response = await fetch(url, DEFAULT_GET_CONFIG);
        await isErrorResponse(response, null, dispatch);
        const assignments = await response.json();
        dispatch({
          type: GET_CABIN_CREW_BUS_ASSIGNMENT,
          payload: assignments,
        });
      } catch (error) {
        toastr.error('Error', error.message);
      } finally {
        dispatch(flagCabinCrewBusAssignmentActivity(false));
      }
    };

const clearCabinCrewBusAssignments = () => (dispatch) =>
  dispatch({
    type: CLEAR_CABIN_CREW_BUS_ASSIGNMENTS,
  });

const clearCabinCrewBusAssignment = () => (dispatch) =>
  dispatch({
    type: CLEAR_CABIN_CREW_BUS_ASSIGNMENT,
  });

const setInitialValues = (data) => (dispatch) =>
  dispatch({
    type: CABIN_CREW_BUS_ASSIGNMENT_INITIAL_VALUES,
    payload: data,
  });

const putCabinCrewBusUnassign =
  async ({ cabinCrewBusAssignmentId, companyBusId }) =>
    async (dispatch) => {
      try {
        dispatch(flagCabinCrewBusAssignmentActivity(true));
        const payload = { cabinCrewBusAssignmentId };
        const url = CABIN_CREW_BUS_UNASSIGN_ENDPOINT;
        const response = await fetch(url, {
          ...DEFAULT_PUT_CONFIG,
          body: JSON.stringify(payload),
        });
        await isErrorResponse(response, null, dispatch);
        await response.json();
        dispatch(
          getCabinCrewBusAssignments({ query: `companyBusId:${companyBusId}` }),
        );
      } catch (error) {
        toastr.error('Error', error.message);
      } finally {
        dispatch(flagCabinCrewBusAssignmentActivity(false));
      }
    };

const postCabinCrewBusAssign =
  async ({ busId, cabinCrewId, cabinCrewTypeId, companyBusId }) =>
    async (dispatch) => {
      try {
        dispatch(flagCabinCrewBusAssignmentActivity(true));
        const payload = { busId, cabinCrewId, cabinCrewTypeId };
        const url = CABIN_CREW_BUS_ASSIGN_ENDPOINT;
        const response = await fetch(url, {
          ...DEFAULT_POST_CONFIG,
          body: JSON.stringify(payload),
        });
        await isErrorResponse(response, null, dispatch);
        await response.json();
        dispatch(
          getCabinCrewBusAssignments({ query: `companyBusId:${companyBusId}` }),
        );
      } catch (error) {
        toastr.error('Error', error.message);
      } finally {
        dispatch(flagCabinCrewBusAssignmentActivity(false));
      }
    };

const exportFile = () => async (dispatch) => {
  try {
    dispatch(flagGettingCabinCrewAssignments(true));
    const url = `${EXPORT_CABIN_CREW_BUS_ASSIGNMENT_ENDPOINT}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', 'Asignacion-Bus.xlsx');
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingCabinCrewAssignments(false));
  }
}

export {
  flagGettingCabinCrewAssignments,
  getCabinCrewBusAssignments,
  clearCabinCrewBusAssignments,
  getCabinCrewBusAssignment,
  clearCabinCrewBusAssignment,
  flagCabinCrewBusAssignmentActivity,
  setInitialValues,
  putCabinCrewBusUnassign,
  postCabinCrewBusAssign,
  exportFile
};
